export interface Identity {
  visitor_id: string;
  anonymous_id: string;
  session_id: string;
  server_session_id?: string;
  pageview_id: string;
  user_id?: string;
}

export const COOKIE_NAMES = {
  VISITOR_ID: "ets_vid",
  ANONYMOUS_ID: "ets_aid",
  USER_ID: "ets_uid",
  SERVER_SESSION_ID: "ets_ssid",
  CLIENT_SESSION_ID: "ets_csid",
  PAGEVIEW_ID: "ets_pvid",
  SESSION_QUERY: "ets_sq",
} as const;

export type CookieName = (typeof COOKIE_NAMES)[keyof typeof COOKIE_NAMES];

export const TTL = {
  VISITOR_ID_SECONDS: 2 * 365 * 24 * 60 * 60,
  ANONYMOUS_ID_SECONDS: 2 * 365 * 24 * 60 * 60,
  USER_ID_SECONDS: 2 * 365 * 24 * 60 * 60,
  SESSION_SECONDS: 30 * 60,
  SERVER_SESSION_SECONDS: 30 * 24 * 60 * 60,
  PAGEVIEW_SECONDS: 5 * 60,
  SESSION_QUERY_SECONDS: 30 * 60,
} as const;
